module.exports = __webpack_public_path__ + "static/img/cus-girl-vn.b0afbc2e.png";